import { call, put, select, takeEvery } from "redux-saga/effects";
import { setAttributeRelatorio, triggerLoadRelatorio } from "./RelatorioSlice";
import { server_url } from '../core/config_geral'
import axios from 'axios';

function* doLoadRelatorio() {
    yield put(setAttributeRelatorio({
        campo: "loading",
        valor: true
    }))

    var token = yield select((state) => state.auth.token)

    var payload = {
        "action": "REL_DOWNLOAD_RELATORIO",
        "runNow": true,
        "payload": JSON.stringify({
            "codigo": "ALK_PESQUISA_VENDAS_PERDIDAS_CONSOLIDADA",
            "tenantId": "ae88fa77-75ac-4f2c-98ac-1d732fcbe07c",
            "versao": "latest"
        })
    }

    var formData = new FormData()
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))

    var retornaNome = (r) => {

        if ( typeof r.cliente === 'object') {
            // console.log(r.cliente)
            var nome = ""
            if(typeof r.cliente.nome === 'string' && r.cliente.nome != null &&r.cliente.nome.trim() !== '') {
                nome = r.cliente.nome
            } else {
                nome = r.razaosocial
            }

            return nome + " <br/>" + r.cliente.cpf
        } else {
            return "-";
        }
    }
    var retornaData = (r) => {
        const date = new Date(r.data);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
    var retornaDataOrdenavel = (r) => {
        const date = new Date(r.data);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}/${month}/${day} ${hours}:${minutes}`;
    }
    var retornaObservacao = (r) => {
        var obs = "<b>Observação</b>: <br/>" + ( (r.observacao != null) ? r.observacao : "" )
        if(typeof r.complemento === "object") {
            if(typeof r.complemento.produtoSemelhante != "undefined") {
                obs += "<br/><br/><b>ProdutoSemelhante:</b> <br/>" +r.complemento.produtoSemelhante
            }
            if(typeof r.complemento.finalidade != "undefined" ) {
                obs += "<br/><br/><b>Finalidade:</b> <br/>" + r.complemento.finalidade;
            }
            if(typeof r.complemento.marcaProcurada != "undefined" ) {
                obs += "<br/><br/><b>Marca procurada:</b> <br/>" + r.complemento.marcaProcurada;
            }
            if(typeof r.complemento.produtoOuTipo != "undefined" ) {
                obs += "<br/><br/><b>Produto ou Tipo de produto:</b> <br/>" + r.complemento.produtoOuTipo;
            }
            if(typeof r.complemento.modeloTamanho != "undefined" ) {
                obs += "<br/><br/><b>Modelo ou tamanho:</b> <br/>" + r.complemento.modeloTamanho;
            }
            if(typeof r.complemento.sugestaoPreco != "undefined" ) {
                obs += "<br/><br/><b>Sugestão de preço:</b> <br/>" + r.complemento.sugestaoPreco;
            }
        }

        return obs;
    }

    var respostas = r.data.map(r => {
        // console.log(r)
        return {
            "atendente": r.atendente,
            "canal": r.canal,
            "nome": retornaNome(r),
            // "cpf" : retornaCPF(r),
            "data": retornaData(r),
            "dataOrdenavel" : retornaDataOrdenavel(r),
            "local": r.local,
            "razao": r.razao,
            "observacao": retornaObservacao(r)
        };
    })

    yield put(setAttributeRelatorio({
        campo: "respostas",
        value: respostas
    }))
}

export function* listenTriggerLoadRelatorio() {
    yield takeEvery(triggerLoadRelatorio, doLoadRelatorio)
}